<template>
  <div class="winning">
    <div class="winning_title" v-if="ism == 'PC'"></div>
    <div class="works_changebtn">
      <div :class="herobtn" class="staicbtn public" @click="worksHeroChange(1)">
        英雄皮肤
      </div>
      <div
        :class="soldiersbtn"
        class="staicbtn public"
        @click="worksHeroChange(2)"
      >
        士兵皮肤
      </div>
    </div>
    <div class="winning_listbox">
      <div
        class="winning_list public"
        :class="item.winning_listbg"
        v-for="item in winningList"
        :key="item.id"
      >
        <img :src="item.img" />
        <div class="winning_list_bottombox">
          <div class="winning_list_bottom">
            <div class="works_imgbottom_top">作品名：{{ item.works }}</div>
            <div class="works_imgbottom_bottom public">
              <div class="works_imgbottom_bottom_left">
                作者：{{ item.author }}
              </div>
              <!-- <div class="works_imgbottom_bottom_right">1</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="winning_bottom public">
      <div class="winning_bottom_title public">优秀奖：</div>
      <div class="goodPrizebox">
        <div class="goodPrize" v-for="item in goodPrize" :key="item.id">
          {{ item.name }}
        </div>
      </div>
      <div class="winning_bottom_title public">人气奖：</div>
      <div class="sentimentPrizebox">
        <div
          class="sentimentPrize"
          v-for="item in sentimentPrize"
          :key="item.id"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "winning",
  props: {
    ism: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      herobtn: "currbtn",
      soldiersbtn: "btn",
      winningList: [],
      goodPrize: [],
      sentimentPrize: [],
    };
  },
  mounted() {
    this.worksHeroChange(1);
  },
  methods: {
    worksHeroChange(id) {
      if (id == 1) {
        this.herobtn = "currbtn";
        this.soldiersbtn = "btn";
        this.winningList = [
          {
            id: 0,
            winning_listbg: "winning_included",
            works: "托娃•枫色浪客",
            author: "COOLER",
            img: require("@/assets/img/pc/winning/hero_1.png"),
          },
          {
            id: 1,
            winning_listbg: "winning_one",
            works: "卢克蕾蒂娅•黑色爱丽丝",
            author: "兔宝宝Bern",
            img: require("@/assets/img/pc/winning/hero_2.png"),
          },
          {
            id: 2,
            winning_listbg: "winning_two",
            works: "卢克蕾蒂娅•黑童话爱丽丝",
            author: "大猫蘸酱",
            img: require("@/assets/img/pc/winning/hero_3.png"),
          },
          {
            id: 3,
            winning_listbg: "winning_two",
            works: "帕希尔•蝴蝶夫人",
            author: "欧洲大总管",
            img: require("@/assets/img/pc/winning/hero_4.png"),
          },
          {
            id: 4,
            winning_listbg: "winning_three",
            works: "托娃•尼罗河的黑猫",
            author: "黑椒牛腩粉",
            img: require("@/assets/img/pc/winning/hero_5.png"),
          },
          {
            id: 5,
            winning_listbg: "winning_three",
            works: "茉•海色灯火",
            author: "蟹丸丸",
            img: require("@/assets/img/pc/winning/hero_6.png"),
          },
          {
            id: 6,
            winning_listbg: "winning_three",
            works: "克拉蕾特•群星之蓝",
            author: "风音",
            img: require("@/assets/img/pc/winning/hero_7.png"),
          },
        ];
        this.goodPrize = [
          { id: 0, name: "黑骑士•花嫁——魔法少女老王" },
          { id: 1, name: "卢克蕾蒂娅•初绽的少女——Measho" },
          { id: 2, name: "海恩•夏季浪潮——脱粒" },
          { id: 3, name: "拉姆达•给你一个金苹果——奥黛丽赫本" },
          { id: 4, name: "艾尔文•光之脉冲——万先森是三日" },
          { id: 5, name: "诺埃米•浪沫蝶影——Apus" },
          { id: 6, name: "弗洛朗蒂娅•战场之花——风见芽衣久" },
          { id: 7, name: "诺埃米•机械战意——老孙" },
          { id: 8, name: "Sp娜姆•绯色猎手——エルウィン" },
          { id: 9, name: "莉亚娜•流浪护士——凯珞" },
        ];
        this.sentimentPrize = [
          { id: 0, name: "罗泽希尔•焰火的新娘——魁枭" },
          { id: 1, name: "女神化身•天堂织羽——星梦之翼" },
          { id: 2, name: "莉亚娜•幽兰之梦——vic" },
          { id: 3, name: "降生之光•夏天与游戏——尼多卡W" },
          { id: 4, name: "伊梅尔达•黑荆棘晚礼服复刻版——库玛库玛库" },
        ];
      } else {
        this.herobtn = "btn";
        this.soldiersbtn = "currbtn";
        this.winningList = [
          {
            id: 0,
            winning_listbg: "winning_included",
            works: "城堡巨人",
            author: "新人小男",
            img: require("@/assets/img/pc/winning/soldiers_1.png"),
          },
          {
            id: 1,
            winning_listbg: "winning_one",
            works: "厨娘巨魔",
            author: "蟹丸丸",
            img: require("@/assets/img/pc/winning/soldiers_2.png"),
          },
          {
            id: 2,
            winning_listbg: "winning_two",
            works: "兔兔出击",
            author: "绿头鸭",
            img: require("@/assets/img/pc/winning/soldiers_3.png"),
          },
          {
            id: 3,
            winning_listbg: "winning_two",
            works: "蒲扇飞羽",
            author: "魔法少女老王",
            img: require("@/assets/img/pc/winning/soldiers_4.png"),
          },
          {
            id: 4,
            winning_listbg: "winning_three",
            works: "赶稿画师",
            author: "Apus",
            img: require("@/assets/img/pc/winning/soldiers_5.png"),
          },
          {
            id: 5,
            winning_listbg: "winning_three",
            works: "月光狂想曲",
            author: "Qmia",
            img: require("@/assets/img/pc/winning/soldiers_6.png"),
          },
          {
            id: 6,
            winning_listbg: "winning_three",
            works: "糖果喵咪",
            author: "呱呱",
            img: require("@/assets/img/pc/winning/soldiers_7.png"),
          },
        ];
        this.goodPrize = [
          { id: 0, name: "阿努比斯的审判——巴斯苔特" },
          { id: 1, name: "海怪之声——我是狗不是猫" },
          { id: 2, name: "治愈仙子——东方小离" },
          { id: 3, name: "月酱——Measho" },
          { id: 4, name: "竞泳少女——牛高达" },
          { id: 5, name: "缤纷银河——欧洲大总管" },
          { id: 6, name: "童话狼灭——抠脚汉" },
          { id: 7, name: "钢翼猛禽——库玛库玛库" },
          { id: 8, name: "泡沫之海——魁枭" },
          { id: 9, name: "白衣天使•未来——兔宝宝Bern" },
        ];
        this.sentimentPrize = [
          { id: 0, name: "装甲碎壳者——风音" },
          { id: 1, name: "防爆天使——小虹" },
          { id: 2, name: "暗矿守卫——vic" },
          { id: 3, name: "龙裔女仆——小西瓜" },
          { id: 4, name: "圣王铁锤——纱织变成onishi" },
        ];
      }
    },
  },
};
</script>
<style scoped>
</style>